module.exports = __webpack_public_path__ + "static/img/egg_b_19.bb60402.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_19.png
// module id = pSLu
// module chunks = 1